import type { BloomMenuTheme } from '@iheartjane/data-access';

interface SignInPromptColors {
  button: string;
  buttonText: string;
}

// Keep in sync with business-admin's signInPrompt/types.ts DEFAULTS and the
// API's default_theme.login_prompt (BloomOperatorConfig).
const DEFAULTS = {
  button: '#0E0E0E',
  button_text: '#FFFFFF',
  cta_label: 'Sign up or sign in',
  desktop_line_1: 'Fast, secure checkout',
  desktop_line_2: 'Personalized recommendations',
  desktop_line_3: 'View order history anytime',
  header: 'Get more with a free account!',
  mobile_copy:
    'Enjoy fast, secure mobile checkout, personalized recommendations, and view order history anytime.',
  mobile_header: 'Get more with a free account!',
} as const;

// AIQ stores have a loyalty program, so the third bullet pitches points
// instead of order history.
const AIQ_OVERRIDES = {
  desktop_line_3: 'Earn points with every purchase',
  mobile_copy:
    'Enjoy fast, secure mobile checkout, personalized recommendations, and earn points with every purchase.',
} as const;

export const getSignInPromptDefaults = (hasAiqIntegration: boolean) =>
  hasAiqIntegration ? { ...DEFAULTS, ...AIQ_OVERRIDES } : DEFAULTS;

export const resolveSignInPromptColors = (
  theme: BloomMenuTheme
): SignInPromptColors => {
  const lp = theme.bloom?.login_prompt?.colors;
  const primary = theme.bloom?.colors?.primary;
  return {
    button: lp?.button || primary?.main || DEFAULTS.button,
    buttonText: lp?.button_text || primary?.contrast || DEFAULTS.button_text,
  };
};
